import { render, staticRenderFns } from "./Empleador.vue?vue&type=template&id=7d2edf76&scoped=true"
import script from "./Empleador.vue?vue&type=script&lang=js"
export * from "./Empleador.vue?vue&type=script&lang=js"
import style0 from "./Empleador.vue?vue&type=style&index=0&id=7d2edf76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2edf76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2edf76')) {
      api.createRecord('7d2edf76', component.options)
    } else {
      api.reload('7d2edf76', component.options)
    }
    module.hot.accept("./Empleador.vue?vue&type=template&id=7d2edf76&scoped=true", function () {
      api.rerender('7d2edf76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibos/Empleador.vue"
export default component.exports